document.body.addEventListener('click', function (e) {
    const trigger = e.target.closest('.open-modal');
    // console.log(e.target);
    if (trigger) {
        console.log('dog');
        e.preventDefault();
        console.log('Clicked modal trigger');

        document.documentElement.classList.toggle('lock-scroll');

        const postId = e.target.getAttribute('data-post-id');
        if (!postId) {
            console.warn('No post ID found');
            return;
        }

        // Show loading
        document.body.classList.add('modal-loading');
        console.log('Fetching content for post ID:', postId);

        fetch(`/wp-admin/admin-ajax.php?action=load_modal_content&post_id=${postId}`)
            .then(res => res.text())
            .then(html => {
                const modalWrapper = document.createElement('div');
                modalWrapper.classList.add('modal-wrapper');
                modalWrapper.innerHTML = html;
                document.body.appendChild(modalWrapper);

                // Show modal
                modalWrapper.classList.add('is-visible');

                // Close events
                modalWrapper.addEventListener('click', (event) => {
                    const closeTrigger = event.target.closest('.modal-close, .modal-overlay, .modal--projects__overlay, .modal--projects__close');
                    if (closeTrigger) {
                        closeModal(modalWrapper);
                    }
                });
            })
            .catch(err => {
                console.error('Modal AJAX error:', err);
            })
            .finally(() => {
                document.body.classList.remove('modal-loading');
            });
    }
});

function closeModal(modalWrapper) {
    setTimeout(() => {
        console.log('Closing modal');
        if (!modalWrapper) {
            console.error('modalWrapper is undefined or null');
            return;
        }
        modalWrapper.remove();
        document.querySelector('html').classList.remove('lock-scroll');
    }, 300); // Delay to match CSS transition (if any)
}
// Initialize modals
// openModal();




function findMarkerByPostId(postId) {
    const map = jQuery.goMap.map;
    let foundMarker = null;

    function search(layer) {
        if (foundMarker) return;

        // Some markers store ID in options.id
        if (layer._latlng && (layer.options?.post_id == postId || layer.options?.id == postId)) {
            foundMarker = layer;
            return;
        }

        if (layer._layers) {
            Object.values(layer._layers).forEach(sub => search(sub));
        }
    }

    Object.values(map._layers).forEach(layer => search(layer));
    return foundMarker;
}

function handlePropertyClick(e) {
    const article = e.target.closest('.c-article__properties .geodir-listing');
    if (!article) return;

    e.preventDefault();

    const postId = article.dataset.postId;
    const marker = findMarkerByPostId(postId);

    if (marker) {
        const map = jQuery.goMap.map;
        map.setView(marker._latlng, 15);

        marker.fire('click');

        // Open the popup if it exists
        if (marker._popup) {
            marker._popup._isOpen || marker._popup.openOn(map);
        } else {
            console.warn('Marker has no popup:', marker);
        }

        // Scroll to map on mobile
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
            const mapElement = document.querySelector('.b-properties__map');
            if (mapElement) {
                const elementPosition = mapElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - 100;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
            }
        }
    } else {
        console.warn('Marker not found for post ID', postId);
    }
}

document.addEventListener('click', handlePropertyClick);

// Remove href from zoom controls to prevent scrolling
function fixZoomControls() {
    const zoomControls = document.querySelectorAll('.leaflet-control-zoom-in, .leaflet-control-zoom-out');
    zoomControls.forEach(control => {
        control.removeAttribute('href');
    });
}

// Run on load and periodically check for new maps
fixZoomControls();
setTimeout(fixZoomControls, 500);
setTimeout(fixZoomControls, 1000);
setTimeout(fixZoomControls, 2000);

// Also fix when new content is added
const observer = new MutationObserver(fixZoomControls);
observer.observe(document.body, { childList: true, subtree: true });
